import React from 'react';
import { Chat } from '@material-ui/icons';
import { CellMeasurerCache } from 'react-virtualized';
import { IconButton, ClickAwayListener } from '@material-ui/core';

import NotificationList from '../ManagerNotificationList/layout';
import axios from '../../config/axiosInstance';
import { parseJSONRawDate, formatDate, ifToday } from '../../shared/dateFactory';

export default function ({
  state,
  onCreateNewNotification,
  onOpenList,
}) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const formatCreationDate = (rawDate) => {
    const date = parseJSONRawDate(rawDate);

    if (ifToday(date)) {
      return 'hoje';
    }

    return formatDate(date, 'dd/MM');
  };

  const fetchItems = () => {
    setLoading(true);
    axios.get('/pushNotificationsMessage/manager')
      .then((response) => {
        const data = response.data.map(item => ({
          text: item.message,
          author: item.sender,
          viewsDetails: `${item.amountRead}/${item.amountSend}`,
          creationDate: formatCreationDate(item.dtSender),
          details: {
            read: item.read,
            received: item.received,
            pending: item.notReceived,
          },
        }));
        setItems(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  React.useEffect(fetchItems, []);

  const handleClick = () => {
    if (state === 'CLOSED') {
      fetchItems();
    }
    onOpenList();
  };

  const handleClickAway = () => {
    if (state === 'OPEN_LIST') {
      onOpenList();
    }
  };


  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <IconButton onClick={handleClick} style={{bottom:'-5%'}}>
          <Chat color="Primary" />
        </IconButton>

        {state === 'OPEN_LIST' && (
          <NotificationList
            newNotification={onCreateNewNotification}
            items={items}
            loading={loading}
            cache={new CellMeasurerCache({
              rowHeight: 90,
              fixedWidth: true,
            })}
          />
        )}
      </div>
    </ClickAwayListener>
  );
}
